<template>
	<form class="form-padrao">
    <div class="relative-form">
			<label for="">Mensagem:</label>
			<textarea name="" id="" cols="30" rows="10" v-model="data.message"></textarea>
    </div>
    <div class="relative-form">
			<label for="">Arquivo:</label>
			<div class="inputfile-box">
				<input type="file" :id="'file' + interacao" ref="file" class="inputfile" multiple @change="handleFileUpload(interacao)"
>
				<label :for="'file' + interacao" class="input-fake">
					<span :id="'file-name' + interacao" class="file-box"> 0 arquivo(s) selecionados(s)</span>
					<span class="file-button">
						SELECIONAR
					</span>
				</label>
			</div>
    </div>
    <button type="button" class="btn-padrao btn-azul btn-send" @click="emit()">Enviar</button>
	</form>
</template>
<script>
	import formatMixin from '../../../../../../../../../resources/assets/js/mixins/formatMixin';
	
	export default {
		mixins: [formatMixin],
		props: {
			interacao : Number
		},
		data() {
			return {
				data : { 
					message : '',
					interacao : this.interacao,
					file : '0'
				}
			}
		},
		methods: {
			emit() {
				let scope   = this;
				var data = this.data;
				$('#file-name' + this.interacao).text('0 arquivo(s) selecionado(s)');
				this.$emit('sendStatus', data);
				this.data.message = '';
				this.data.file = '';
			},
			handleFileUpload(target) {
				$('#file-name' + this.interacao).text(this.$refs.file.files.length + ' arquivo(s) selecionado(s)');
				this.$emit('updateFile', this.$refs.file);
			}
		}
	}

</script>